import { render, staticRenderFns } from "./website_report.vue?vue&type=template&id=21989a32&scoped=true"
import script from "./website_report.vue?vue&type=script&lang=js"
export * from "./website_report.vue?vue&type=script&lang=js"
import style0 from "./website_report.vue?vue&type=style&index=0&id=21989a32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21989a32",
  null
  
)

export default component.exports